import { checkUserResourcePermissions } from 'sonata-static-storage/lib/helpers/user.helpers';

import { MEDIA_QUALITY_SECTION_PERMISSIONS } from './getPermittedMediaQuality.helper';

import type { UserInterface } from 'sonata-static-storage/lib/schemas/user/user.schema';
import type { UserRoleInterface } from 'sonata-static-storage/lib/schemas/user/userRole.schema';

// There is no section-level permission: the section is available when the user has any of its subsections
export function hasMediaQualityPermission(user: UserInterface, userRoles: UserRoleInterface[]): boolean {
  return Object.values(MEDIA_QUALITY_SECTION_PERMISSIONS).some(permission =>
    checkUserResourcePermissions(permission, user, userRoles)
  );
}
